import React from "react"
import { BreadcrumbComponent } from "../../components/common/breadcrumb"
import { DefaultPageComp } from "../../components/defaultPage"
import { SportsComponent } from "../../components/sports"

export const SportsPage = () => {
  return <>
    <DefaultPageComp>
      <BreadcrumbComponent />
      <SportsComponent />
    </DefaultPageComp>
  </>
}